import React, { useEffect, useState } from "react";
import Header from "./Header";
import { ApiCall, Colors, Web_url } from "../../common/Const";
import { images } from "../../common/Images";
import Card from "./Card";
import "../../styles/styles.css";
// import lefimg from "../../assets/pink2.png";
import Footer from "../pages/Footer";
// import InnerImageZoom from "react-inner-image-zoom";
// import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import ReactImageZoom from "react-image-zoom";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import store from "../../redux/Store";
import { useSelector } from "react-redux";
import EncryptDecrypt from "../../common/Crypto";

const Productdetails = () => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  let { state } = useLocation();
  let { p_detail } = state;
  const [p_details,setPdetails] = useState(p_detail);
  const [karat, setKarat] = useState(p_details.varient[0].karat);
  const [size, setSize] = useState(p_details.varient[0].size);
  const [allVarData, setAllVarData] = useState([]);
  const [availableKarat, setAvailableKarat] = useState([]);
  const [varientdata, setvarientdata] = useState("");
  const [alreadyinCart, setalreadyinCart] = useState(false);
  const [favIcon, setfavIcon] = useState(0);
  const [cusId, setcusId] = useState(0);

  const [collectionData,setCollectionData] = useState([]);
  const RdxCart = useSelector((state) => state.cart);

  const[selectedImg,setSelectedImg] = useState(p_details.product_image[0].id);

  const [mainImg, setMainImage] = useState(p_details.product_image[0].url);
  console.log(selectedImg);

  const navigate  = useNavigate();

useEffect(() => {
  setPdetails(p_detail);
  setMainImage(p_detail.product_image[0].url);
}, [p_detail]);
  
  useEffect(() => {
    const collectionParams = {
      branch_type: "collection",
      branch_id: p_details.collect_id,
      customer_id: cusId,
      // page_number: 0,
    };
    console.log(collectionParams, "wfefb");
    ApiCall("webFindClick", collectionParams).then((data) => {
      console.log(data, "fwrwtyig");
      setCollectionData(data);
    });
  }, [p_details]);
  

  useEffect(() => {
    isInCart();
  }, [RdxCart, varientdata]);

    const DecryptData = async () => {
      let type = "decrypt";
      let format = "text";
      let id = localStorage.getItem("customerId");
      await EncryptDecrypt(id, type, format, (response) => {
        console.log("decode -->", response);
        setcusId(response);
      });
    };

    useEffect(() => {
      DecryptData();
    }, []);

    console.log(cusId);

  {/**check if cart is already set or not */}
  const isInCart = () => {
    if (varientdata === "") {
      let cartarr = Object.values(RdxCart).filter((val) => {

        // console.log(val.product_id);
        if (
          val.product_id == p_details.product_id &&
          val.order_sizes == p_details.varient[0].size &&
          val.karat == p_details.varient[0].karat
        ) {
          return true;
        } else {
          return false;
        }
      });
      console.log(cartarr)


      cartarr.length === 1?setalreadyinCart(true):setalreadyinCart(false);
      // console.log(cartarr.length);
    }

    else {

      let cartarr = Object.values(RdxCart).filter((val) => {
        if (
          val.product_id == p_details.product_id &&
          val.order_sizes == varientdata.size &&
          val.karat == varientdata.karat
        ) {
          return true;
        } else {
          return false;
        }
      });
       cartarr.length === 1 ? setalreadyinCart(true) : setalreadyinCart(false);
        // console.log(cartarr.length);
    }
  };
  useEffect(() => {
    setData();
  }, []);

  async function setData() {
    let karatsAvail = [];
    p_details.varient.forEach((val) => {
      karatsAvail.push(val.karat);
    });
    karatsAvail = [...new Set(karatsAvail)];
    setAvailableKarat(karatsAvail);
    setKarat(karatsAvail[0]);

    let allVarientData = [];
    karatsAvail.forEach((val) => {
      let karatData = [];
      p_details.varient.forEach((value) => {
        if (val === value.karat) {
          karatData.push(value);
        }
      });
      allVarientData.push({ value: val, data: karatData });
    });
    setAllVarData(allVarientData);
  }

  const handleSizeChange = (data) => {
    setSize(data.size);
    setvarientdata(data);
  };

  async function additemtoCart() {
    if (varientdata === "") {
      store.dispatch({
        type: "addToCart",
        payload: {
          product_id: p_details.product_id,
          product_name: p_details.product_name,
          product_image: p_details.product_image,
          order_sizes: p_details.varient[0].size,
          karat: p_details.varient[0].karat,
          weight: p_details.varient[0].weight,
          order_price: p_details.varient[0].offer_price,
          // varient: varientname,
          variant_id: p_details.varient[0].id,
          packing_charges: p_details.packing_charges,
        },
      });
    } else {
      store.dispatch({
        type: "addToCart",
        payload: {
          product_id: p_details.product_id,
          product_name: p_details.product_name,
          product_image: p_details.product_image,
          order_sizes: varientdata.size,
          karat: varientdata.karat,
          weight: varientdata.weight,
          order_price: varientdata.offer_price,
          // varient: varientname,
          variant_id: varientdata.id,
          packing_charges: p_details.packing_charges,
        },
      });
    }
  }

  const additemToFav = () => {
    {
      /**add fav */
    }
    var favParams = { customer_id: cusId, product_id: p_details.product_id };

    if (favIcon == 0) {
      ApiCall("addFav", favParams)
        .then((data) => {
          console.log("adeed");
          if (data.message == "Success") {
            setfavIcon(1);
            toast.success("Favourite added", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
          }
        })
        .catch((err) => console.log(err));
    } else if (favIcon == 1) {
      ApiCall("removeFav", favParams)
        .then((data) => {
          if (data.message == "Success") {
            console.log(" removed");
            setfavIcon(0);
            toast.success("Favourite Removed", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
          }
        })
        .catch((err) => console.log(err));
    }
  };
  console.log(allVarData);

  // const imag = [
  //   {
  //     id: "1",
  //     image: images.Hring,
  //   },
  //   {
  //     id: "2",
  //     image: images.Hring,
  //   },
  //   {
  //     id: "3",
  //     image: images.Hring,
  //   },
  //   {
  //     id: "4",
  //     image: images.Hring,
  //   },
  //   {
  //     id: "5",
  //     image: images.Hring,
  //   },
  // ];

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const props = {
    width: windowSize != null && windowSize >= 500 ? 400 : 150,
    zoomWidth: 300,
    img: Web_url.Domain_url + mainImg,
    zoomPosition: windowSize != null && windowSize >= 500 ? "" : "bottom",
  };

  console.log(p_details);

  useEffect(()=>{

     p_details.product_image.map((data)=>{

     if(data.id == selectedImg){

      setMainImage(data.url);
     }
     })
    },[selectedImg])

  return (
    <>
      <Header make={true} />
      <div
        className=" p-4 prdouct-details "
        style={{ backgroundColor: "#fef4f7" }}
      >
        <h3 className=" mb-2 heading">{p_details.product_name}</h3>
        <div className="contianer">
          <div className="row top-side mb-5">
            <div className="col-10 col-lg-2  col-md-2  order-lg-1 order-md-2 order-2 left-side-image ">
              <ul className="main-sub-image-list">
                {p_details.product_image.map((sngleimg, index) => {
                  return (
                    <li>
                      <img
                        src={Web_url.Domain_url + sngleimg.url}
                        className="main-sub-image m-1  "
                        style={{
                          backgroundColor: Colors.white_color,
                          border:
                            selectedImg == sngleimg.id
                              ? "1px solid #126a38"
                              : "",
                        }}
                        width="80px"
                        onClick={() => {
                          setSelectedImg(sngleimg.id);
                        }}
                      ></img>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div
              className="col-10 col-lg-4 col-md-8  middle-im  order-lg-2 order-md-2 order-1 "
              style={{ backgroundColor: Colors.white_color }}
            >
              <div className="imagemagnigy">
                <ReactImageZoom {...props} />
              </div>
            </div>
            <div className="col-11 col-lg-5 col-md-11 col-sm-12 order-3 p-details">
              <div
                className=" details-side border border-0 "
                style={{
                  height: "max-content",
                  backgroundColor: Colors.white_color,
                  border: "0px",
                  borderRadius: "20px",
                  padding: "30px",
                }}
              >
                <div className="d-flex flex-row justify-content-between align-items-center  rate ">
                  <div className="d-flex ">
                    <h3>
                      ₹
                      {varientdata.offer_price !== undefined
                        ? varientdata.offer_price
                        : p_details.varient[0].offer_price}
                    </h3>
                    <h5
                      className="ps-4 text-muted"
                      style={{ textDecoration: "line-through" }}
                    >
                      ₹
                      {varientdata.actual_price !== undefined
                        ? varientdata.actual_price
                        : p_details.varient[0].actual_price}
                    </h5>
                  </div>
                  <span className="heart " style={{ cursor: "pointer" }}>
                    <i
                      class={
                        favIcon == 1
                          ? "fa-sharp fa-solid fa-heart"
                          : "fa-regular fa-heart"
                      }
                      onClick={() => additemToFav()}
                    ></i>
                    {/* <i class="fa-sharp fa-solid fa-heart"></i> */}
                  </span>
                </div>
                <div></div>
                <div className="produc-title">
                  <h3
                    className="mt-4"
                    style={{ fontWeight: "bold", color: "#126a38" }}
                  >
                    {p_details.product_name}
                  </h3>
                  <p className="short-description">
                    {p_details.short_description}
                  </p>
                </div>
                <h4 className="choosecart">Choose Carat</h4>
                <div className="d-flex gap-2 mt-3">
                  {availableKarat.map((val, index) => {
                    return (
                      <button
                        type="button "
                        id="karat-buttons"
                        className="btn btn-lg"
                        style={{
                          backgroundColor:  "#126a38" ,
                          color:  "white" ,
                        }}
                        onClick={() => setKarat(val)}
                      >
                        {val} CT
                      </button>
                    );
                  })}
                </div>
                <h4
                  style={{
                    color: "#126a38",
                    paddingTop: "20px",
                    fontWeight: 50,
                    fontFamily: "AvenirLTStdMedium",
                  }}
                >
                  Select Size
                </h4>
                <div className="d-flex gap-2 mt-3 ">
                  {allVarData.map((val) => {
                    return (
                      val.value === karat &&
                      val.data.map((value, index) => {
                        return (
                          <button
                            type="button "
                            id="inch-buttons"
                            className="btn btn-lg"
                            style={{
                              backgroundColor:
                                size == value.size ? "#126a38" : "",
                              color:  "white",
                            }}
                            onClick={() => handleSizeChange(value)}
                          >
                            {value.size} mm
                          </button>
                        );
                      })
                    );
                  })}
                </div>

                <div className="about-product mt-4">
                  <h4
                    style={{
                      color: "#126a38",
                      fontWeight: 50,
                      fontFamily: "AvenirLTStdMedium",
                    }}
                  >
                    About the product
                  </h4>
                  <p style={{ fontFamily: "AvenirLTStdLight" }}>
                    {p_details.product_description}
                  </p>
                </div>
                <div className="productdtls">
                  <h4
                    style={{
                      color: "#126a38",
                      fontWeight: "50",
                      fontFamily: "AvenirLTStdMedium",
                    }}
                  >
                    productDetails
                  </h4>
                  <span style={{ color: "#126a38" }}>product id: </span>{" "}
                  {p_details.product_id}
                  <br />
                  <div className="d-flex jusify-content-center align-items-center gap-2">
                    <span style={{ color: "#126a38" }}>Dimensions:</span>
                    <small style={{ fontFamily: "AvenirLTStdMedium" }}>
                      Length-{p_details.dimensions_length} mm,Width-
                      {p_details.dimensions_width}
                    </small>
                  </div>
                </div>
                <div className="certified mt-3">
                  <h4
                    style={{
                      color: "#126a38",
                      fontWeight: "50",
                      fontFamily: "AvenirLTStdMedium",
                    }}
                  >
                    Certified By
                  </h4>
                  <img src={images.certi} style={{ width: "80px" }}></img>
                </div>
                <div className="delivery mt-3">
                  <h4
                    style={{
                      color: "#126a38",
                      fontWeight: "50",
                      fontFamily: "AvenirLTStdMedium",
                    }}
                  >
                    Delivery Options
                  </h4>
                  <small>
                    Standard Delivery
                    <i
                      class="fa-solid fa-circle-check"
                      style={{ color: "green", paddingLeft: "3px" }}
                    ></i>
                  </small>{" "}
                  <br />
                  <small>
                    Cash On Delivery(COD)
                    <i
                      class="fa-solid fa-circle-check"
                      style={{ color: "green", paddingLeft: "3px" }}
                    ></i>
                  </small>
                </div>
                <div className="d-flex justify-content-center mt-5 mb-5">
                  {alreadyinCart === false ? (
                    <button
                      type="button"
                      id="addbag"
                      className="btn btn-lg"
                      onClick={() => additemtoCart()}
                    >
                      Add to bag
                    </button>
                  ) : (
                    <button
                      type="button"
                      id="addbag"
                      className="btn btn-lg"
                      onClick={() => navigate("/mycart")}
                    >
                      View cart
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <hr className=" mb-4" style={{ color: Colors.Base_color }} />
          {collectionData.length !=0 ?
          
          
          
          <Card collections={collectionData} cusId={cusId} />: <span className="d-flex justify-content-center pt-5 pb-5">No Data</span>
          }
        </div>
      </div>
      <ToastContainer />
      <Footer />
    </>
  );
};

export default Productdetails;
